module.exports = __webpack_public_path__ + "img/United Arab Emirates.600ba9b9.svg";